import { getAccountApiHelper } from '../../common/utils/apiHelpers';

//action types
export const TAGS_REQUEST = 'TAGS_REQUEST';
export const TAGS_SUCCESS = 'TAGS_SUCCESS';
export const TAGS_FAILURE = 'TAGS_FAILURE';
export const ADD_TAG = 'ADD_TAG';

// Action Creators
function tagsRequest() {
  return {
    type: TAGS_REQUEST,
    isFetching: true
  };
}

function tagsSuccess(tags) {
  return {
    type: TAGS_SUCCESS,
    tags: tags
  };
}

function tagsFailure(error) {
  return {
    type: TAGS_FAILURE,
    error
  };
}

export function addTag(tag, tagType) {
  return {
    type: ADD_TAG,
    tag,
    tagType
  };
}

// Thunks/Async Action Creators
export function getTags() {
  return dispatch => {
    dispatch(tagsRequest());
    return getAccountApiHelper('/tags')
      .then(response => dispatch(tagsSuccess(response.data)))
      .catch(rejected => dispatch(tagsFailure(rejected)));
  };
}
